<template>
  <div>
    <div class="bg" style="margin-bottom: 20px">
      <FxedTop></FxedTop>
    </div>
    <div class="page">
      <div class="container">
        <div class="pageTitle">
          <!-- 考试类型 -->
          您正在浏览：个人参考
          <!-- <span v-if="examType == 1">全班统考</span>
          <span v-if="examType == 2">个人参考</span>
          <span v-if="examType == 3">学员刷题</span> -->
        </div>
        <div style="display: flex">
          <!-- 试卷 -->
          <div class="question">
            <div class="card" v-if="
              question.examinationPaperConfig &&
              question.examinationPaperConfig.singleCount > 0
            ">
              <div class="subTitle">
                单选题:
                <span class="subText">共{{ question.examinationPaperConfig.singleCount }}题, 合计{{
                  question.examinationPaperConfig.singleCount *
                  question.examinationPaperConfig.singleScore
                }}分</span>
              </div>
              <div v-for="(item, index) in question.singleQuestionList" :key="index">
                <div class="questionItem">
                  <span class="xuhao">{{ index + 1 }}</span>
                  <div class="timu">
                    {{ item.questionStem }}
                  </div>
                  <div>
                    <div style="
                        display: flex;
                        align-items: center;
                        margin-right: 30px;
                        margin-bottom: 20px;
                        cursor: pointer;
                      " v-for="(itemm, indexx) in item.questionOptionList" :key="indexx" @click="
                        checkboxChange(item, index, itemm, indexx, 'single')
                        ">
                      <img v-if="itemm.isAnswer" style="margin-right: 10px" src="@/assets/isAnswerOk.png" />
                      <img v-else style="margin-right: 10px" src="@/assets/isAnswerNo.png" />
                      <div>{{ itemm.optionNum }}. {{ itemm.optionName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" v-if="
              question.examinationPaperConfig &&
              question.examinationPaperConfig.multipleCount > 0
            ">
              <div class="subTitle">
                多选题:
                <span class="subText">共{{ question.examinationPaperConfig.multipleCount }}题,
                  合计{{
                    question.examinationPaperConfig.multipleCount *
                    question.examinationPaperConfig.multipleScore
                  }}分</span>
              </div>
              <div v-for="(item, index) in question.multipleQuestionList" :key="index">
                <div class="questionItem">
                  <span class="xuhao">{{ index + 1 }}</span>
                  <div class="timu">
                    {{ item.questionStem }}
                  </div>
                  <div>
                    <div style="
                        display: flex;
                        align-items: center;
                        margin-right: 20px;
                        margin-bottom: 20px;
                        cursor: pointer;
                      " v-for="(itemm, indexx) in item.questionOptionList" :key="indexx"
                      @click="changeAnswer(itemm, indexx, item)">
                      <img v-if="itemm.isAnswer" style="margin-right: 10px" src="@/assets/isAnswerOk.png" />
                      <img v-else style="margin-right: 10px" src="@/assets/isAnswerNo.png" />
                      <div>{{ itemm.optionNum }}. {{ itemm.optionName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" v-if="
              question.examinationPaperConfig &&
              question.examinationPaperConfig.trueFalseCount > 0
            ">
              <div class="subTitle">
                判断题:
                <span class="subText">共{{ question.examinationPaperConfig.trueFalseCount }}题,
                  合计{{
                    question.examinationPaperConfig.trueFalseCount *
                    question.examinationPaperConfig.trueFalseScore
                  }}分</span>
              </div>
              <div v-for="(item, index) in question.trueFalseQuestionList" :key="index">
                <div class="questionItem">
                  <span class="xuhao">{{ index + 1 }}</span>
                  <div class="timu">
                    {{ item.questionStem }}
                  </div>
                  <div>
                    <div style="
                        display: flex;
                        align-items: center;
                        margin-right: 20px;
                        margin-bottom: 20px;
                        cursor: pointer;
                      " v-for="(itemm, indexx) in item.questionOptionList" :key="indexx" @click="
                        checkboxChange(item, index, itemm, indexx, 'single')
                        ">
                      <img v-if="itemm.isAnswer" style="margin-right: 10px" src="@/assets/isAnswerOk.png" />
                      <img v-else style="margin-right: 10px" src="@/assets/isAnswerNo.png" />
                      <div>{{ itemm.optionNum }}. {{ itemm.optionName }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="submit">
              <el-button class="moni" @click="subForm">提交试卷</el-button>
            </div>
          </div>
          <!-- 答题卡 -->
          <div class="answerSheet">
            <div class="sheet">
              <div class="title">答题卡</div>
              <div class="time">{{ timer }}</div>
            </div>
            <!-- 单选题 -->
            <div style="border-bottom: 1px solid #ccc; margin-bottom: 20px" v-if="
              question.examinationPaperConfig &&
              question.examinationPaperConfig.singleCount > 0
            ">
              <div class="sheetList">
                <div class="type">单选题</div>
                <div class="typeTotal">
                  共{{ question.examinationPaperConfig.singleCount }}题
                </div>
              </div>
              <div class="sheelitem">
                <div class="item" v-for="item in question.examinationPaperConfig.singleCount" :key="item">
                  {{ item }}
                </div>
              </div>
            </div>
            <!-- 多选题 -->
            <div style="border-bottom: 1px solid #ccc; margin-bottom: 20px" v-if="
              question.examinationPaperConfig &&
              question.examinationPaperConfig.multipleCount > 0
            ">
              <div class="sheetList">
                <div class="type">多选题</div>
                <div class="typeTotal">
                  共{{ question.examinationPaperConfig.multipleCount }}题
                </div>
              </div>
              <div class="sheelitem">
                <div class="item" v-for="item in question.examinationPaperConfig.multipleCount" :key="item">
                  {{ item }}
                </div>
              </div>
            </div>
            <!-- 判断题 -->
            <div v-if="
              question.examinationPaperConfig &&
              question.examinationPaperConfig.trueFalseCount > 0
            ">
              <div class="sheetList">
                <div class="type">判断题</div>
                <div class="typeTotal">
                  共{{ question.examinationPaperConfig.trueFalseCount }}题
                </div>
              </div>
              <div class="sheelitem">
                <div class="item" v-for="item in question.examinationPaperConfig.trueFalseCount" :key="item">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <div v-if="isShowVerify">
      <Verify @success="success" @closeBox="closeBox" :mode="'pop'" :captchaType="'blockPuzzle'"
        :imgSize="{ width: '330px', height: '155px' }" ref="verify"></Verify>
    </div>
  </div>
</template>

<script>
import FxedTop from "@/components/FxedTop.vue";
import Footer from "@/components/Footer.vue";
import request from "@/utils/request";
import Verify from "@/components/verifitionV2/Verify.vue";
export default {
  components: {
    FxedTop,
    Footer,
    Verify,
  },
  data() {
    return {
      isShowVerify: false,
      question: {},
      startTime: null,
      // 倒计时
      timer: null,
      clearTimer: null,
      classGroupId: null,
    };
  },
  created() {
    const { classGroupId } = this.$route.query;
    // 日期格式 yyyy-MM-dd HH:mm:ss
    this.startTime = new Date().toLocaleString().replace(/\//g, "-");
    this.getQuerstion(classGroupId);
    clearInterval(this.clearTimer);
  },
  methods: {
    changeAnswer(item, index) {
      item.isAnswer = !item.isAnswer;
      this.$forceUpdate();
    },
    checkboxChange(item, index, itemm, indexx, type) {
      item.questionOptionList.forEach((e) => {
        if (itemm.id == e.id) {
          e.isAnswer = true;
        } else {
          e.isAnswer = false;
        }
      });
      this.$forceUpdate();
    },
    async getQuerstion(classGroupId) {
      const res = await request({
        url: `/ework2/exam/examinationPaper/generateExamQuestion/${classGroupId}`,
        method: "get",
        params: {},
      });
      if (res.code == 200) {
        this.question = res.result;
        // 开启答题倒计时
        if (this.question) {
          this.startCount(
            this.question.examDuration ? this.question.examDuration : 60
          );
        } else {
          this.$message.warning("暂无数据, 请联系管理员");
        }
      } else {
        this.$message.error(res.message);
      }
    },
    startCount(count) {
      // 时间格式  01:30:00
      // 计算总秒数
      let ss = count * 60;
      // 开始计数
      this.clearTimer = setInterval(() => {
        // 秒数减一
        ss--;
        if (ss >= 0) {
          // 转换格式为  01:30:00
          this.timer = this.formatTime(ss);
        } else {
          clearInterval(this.clearTimer);
        }
      }, 1000);
    },
    formatTime(ss) {
      let h = Math.floor(ss / 3600);
      let m = Math.floor((ss % 3600) / 60);
      let s = ss % 60;
      return (
        (h > 0 ? (h > 9 ? h : "0" + h) + ":" : "00:") +
        (m > 9 ? m : "0" + m) +
        ":" +
        (s > 9 ? s : "0" + s)
      );
    },
    async success(captchaData) {
      let data = {
        examinationPaperId: this.question.id,
        examPaperToken: this.question.examPaperToken,
        captchaData: captchaData,
        startTime: this.startTime,
        endTime: new Date().toLocaleString().replace(/\//g, "-"),
        answerList: [
          ...this.singleQuestion(),
          ...this.trueFalseQuestion(),
          ...this.multipleQuestion(),
        ],
      };
      const res = await request({
        url: `/ework2/exam/examinationPaper/submitExamPaper`,
        method: "post",
        data: data,
      });
      if (res.code == 200 && res.result) {
        let str = "";
        // 是否及格,0=否,1=是
        if (res.result.isPass) {
          str = `<div style="text-align: center;">
          <div style="color: #66dd7b;font-size: 18px;">成绩合格</div>
          <div>考试课程名称:${res.result.examName}</div>
          <div>回答正确数:${res.result.rightCount}</div>
          <div>答题正确率:${(res.result.accuracy * 100).toFixed(2)}%</div>
          <div>得分:${res.result.score}分</div>
          </div>`;
        } else {
          str = `<div style="text-align: center;">
          <div style="color: red;font-size: 18px;">成绩不合格</div>
          <div>考试课程名称:${res.result.examName}</div>
          <div>回答正确数:${res.result.rightCount}</div>
          <div>答题正确率:${(res.result.accuracy * 100).toFixed(2)}%</div>
          <div>得分:${res.result.score}分</div>
          </div>`;
        }
        this.$alert(str, {
          confirmButtonText: "确定",
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            // this.$router.push({})
            // 返回上一级
            this.$router.go(-1);
          },
        });
      } else {
        this.$message.error(res.message);
      }
    },
    async subForm() {
      this.isShowVerify = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.verify.show();
        }, 1000);
      });
    },
    closeBox() {
      this.isShowVerify = false;
    },
    // 单选题处理
    singleQuestion(item) {
      let arr = [];
      this.question.singleQuestionList.forEach((item) => {
        item.questionOptionList.forEach((itemm) => {
          if (itemm.isAnswer) {
            arr.push({ questionId: item.id, optionNums: itemm.optionNum });
          }
        });
      });
      return arr;
    },
    // 判断题处理
    trueFalseQuestion(item) {
      let arr = [];
      this.question.trueFalseQuestionList.forEach((item) => {
        item.questionOptionList.forEach((itemm) => {
          if (itemm.isAnswer) {
            arr.push({ questionId: item.id, optionNums: itemm.optionNum });
          }
        });
      });
      return arr;
    },
    // 多选题处理
    multipleQuestion(item) {
      let arr = [];
      this.question.multipleQuestionList.forEach((item) => {
        let str = "";
        item.questionOptionList.forEach((itemm) => {
          if (itemm.isAnswer) {
            str = str + itemm.optionNum + ",";
          }
        });
        str = str.substring(0, str.length - 1);
        arr.push({ questionId: item.id, optionNums: str });
      });
      return arr;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  padding-bottom: 50px;
}

.title {
  font-size: 20px;
  height: 50px;
  line-height: 50px;
}

.subTitle {
  font-size: 18px;
  height: 50px;
  line-height: 50px;
}

.moni {
  margin-left: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 22px;
  background: #5096ac;
  color: #fff;
  padding: 20px 40px;
  border-radius: 5px;
  cursor: pointer;
}

.card {
  border: 1px solid #ccc;
  padding-top: 0;
  background: #fff;

  .subTitle {
    background: #f7f7f7;
    padding: 10px 20px;

    .subText {
      display: inline-block;
      margin-left: 10px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      background: #559dbf;
      color: #fff;
      padding: 0 10px;
      border-radius: 20px;
    }
  }
}

.questionItem {
  position: relative;
  padding: 20px 60px;

  .xuhao {
    position: absolute;
    left: 20px;
    top: 20px;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    background: #6a9ce6;
    color: #fff;
    display: inline-block;
    text-align: center;
    line-height: 30px;
  }

  .timu {
    margin-bottom: 20px;
    padding-bottom: 10px;
    font-size: 18px;
    border-bottom: 1px solid #ccc;
  }
}

.submit {
  background: #fff;
  border: 1px solid #ccc;
}

.question {
  flex: 1;
  margin-right: 20px;
}

.answerSheet {
  width: 220px;
  border: 1px solid #ccc;
}

.sheet {
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;

  .title {
    width: 50%;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background: #559dbf;
    font-size: 15px;
  }

  .time {
    width: 50%;
    color: red;
    font-size: 17px;
    font-weight: bold;
  }
}

.sheetList {
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;

  .type {
    width: 50%;
    font-weight: bold;
  }

  .typeTotal {
    width: 50%;
  }
}

.sheelitem {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  padding-top: 0px;

  .item {
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    margin-right: 3px;
    margin-bottom: 3px;
    border: 1px solid #ccc;
  }
}
</style>
